import React from "react";
import MerchantDashboard from "./MerchantDashboard";

const WooCommerceDashboard: React.FC = () => {
  return <MerchantDashboard platform="woocommerce" />;
};

export default WooCommerceDashboard;
